import React from 'react';
import {
  EuiOverlayMask,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
  EuiButton,
  EuiButtonEmpty,
  EuiText,
} from '@elastic/eui';
import { useModal } from "../ModalContext";
import { TranslateLanguage } from './KeywordTranslator';
import './LoginRequiredModal.css';

export function LoginRequiredModal({
  isOpen,
  onClose,
  nextUrl,
  title = '請先登入',
  message = '登入後即可使用「收藏到播放清單」等功能。',
}) {
  const { setLoginModalVisible, setRegisterModalVisible } = useModal();
  if (!isOpen) return null;

  const handleLogin = () => {
    if (nextUrl && typeof window !== 'undefined') {
      sessionStorage.setItem('postLoginRedirect', nextUrl);
    }
    setLoginModalVisible(true);
  };

  const handleRegister = () => {
    setRegisterModalVisible(true);
  };

  return (
    <EuiOverlayMask className="login-required-overlay">
      <EuiModal className="login-required-modal" onClose={onClose} initialFocus="[data-test-subj='loginConfirmBtn']">
        <EuiModalHeader>
          <EuiModalHeaderTitle>
            <h3>{title}</h3>
          </EuiModalHeaderTitle>
        </EuiModalHeader>

        <EuiModalBody className="login-required-body">
          <EuiText>
            <p>{message}</p>
          </EuiText>
        </EuiModalBody>

        <EuiModalFooter className="login-required-footer">
          <EuiButtonEmpty onClick={onClose} data-test-subj="loginCancelBtn">
            {TranslateLanguage(localStorage.userLanguage, "取消")}
          </EuiButtonEmpty>
          <EuiButton fill onClick={handleLogin} data-test-subj="loginConfirmBtn">
            {TranslateLanguage(localStorage.userLanguage, "登入")}
          </EuiButton>
          <EuiButton fill onClick={handleRegister} data-test-subj="registerConfirmBtn">
            {TranslateLanguage(localStorage.userLanguage, "注冊")}
          </EuiButton>
        </EuiModalFooter>
      </EuiModal>
    </EuiOverlayMask>
  );
}
